import { Badge, Button, Card, Checkbox, Divider, List, Tag, Typography, message, notification } from "antd"
import { useEffect, useState } from "react";
// import AddBin from "./AddBin";
import { Empty } from 'antd';
// import ViewGarment from "../Garments/ViewGarment";
import bin_img from '../../../../assets/dashboard/bin_img.png';
import { useLocation, useNavigate } from "react-router";
import ManageBinService from "../../../../services/Dispatch-Centre-Service/ManageBinService";
import ResponseMessage from "../../../Comman/Notification/ResponseMessge";

const BinBlukOutward = ({ userData }) => {


    const [displayBin, setDisplayBin] = useState([]);
    const [displayGarments, setDisplayGarments] = useState(false);
    const [isLoading, setIsLoading] = useState();
    const [selectedBins, setSelectedBins] = useState([]);
    const [removeBtn, showRemoveBtn] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const [api, contextHolder] = notification.useNotification();

    function openNotificationWithIcon(type, title, description) {
        api[type]({
            message: title,
            description,
            duration: 1,
        });
    }

    useEffect(() => {
        const fetchKanbanData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const bin_id = queryParams.get('binId');

            console.log(bin_id);

            setIsLoading(true);
            try {
                const response = await ManageBinService.getBinDatabyBinId(bin_id);
                console.log(response);

                if (Array.isArray(response.data) && response.data.length > 0) {
                    const existingData = JSON.parse(localStorage.getItem('bin_bulk_outward')) || [];

                    const combinedData = [...existingData, ...response.data];

                    const uniqueBins = combinedData.filter(
                        (bin, index, self) =>
                            index === self.findIndex((b) => b.bin_id === bin.bin_id)
                    );

                    localStorage.setItem('bin_bulk_outward', JSON.stringify(uniqueBins));

                    setDisplayBin((prevDisplayBin) => {
                        const mergedDisplayBin = [...prevDisplayBin, ...response.data];
                        const uniqueDisplayBin = mergedDisplayBin.filter(
                            (bin, index, self) =>
                                index === self.findIndex((b) => b.bin_id === bin.bin_id)
                        );
                        return uniqueDisplayBin;
                    });

                } else {
                    openNotificationWithIcon('warning', 'No Data Found', response.message || 'No Bin data available.');
                }
            } catch (error) {
                console.error(error);
                openNotificationWithIcon('error', 'Error', 'An error occurred while fetching data.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchKanbanData();
    }, [location]);


    useEffect(() => {
        const fetchData = async () => {
            console.log(userData);

            try {
                const storedData = JSON.parse(localStorage.getItem('bin_bulk_outward')) || [];

                // Update state with the stored data
                setDisplayBin(storedData);

                console.log("Loaded data from localStorage:", storedData);
            } catch (error) {
                console.error("Error fetching bin data:", error);
            }
        };

        fetchData();
    }, []);



    const handleBulkOutward = async () => {

        try {
            navigate("/dispatch/bulkscan/preview");

        } catch (error) {
            console.error(error);

        }
        // console.log(gomat);

    };

    const handleSelectedBinOutward = async () => {
        if (selectedBins.length === 0) {
            openNotificationWithIcon('warning', 'Warning', 'Bin is Not Selected');
        } else {
            try {
                const userData = JSON.parse(localStorage.getItem("userData"));
                const addedBy = userData?.data?.su_id;

                const binBulkOutward = JSON.parse(localStorage.getItem("bin_bulk_outward")) || [];

                const updatedBinBulkOutward = binBulkOutward.filter(
                    (bin) => !selectedBins.includes(bin.bin_id)
                );
                setDisplayBin(updatedBinBulkOutward);

                localStorage.setItem("bin_bulk_outward", JSON.stringify(updatedBinBulkOutward));

                // message.success("Bin removed Sucessfully !"); 
                ResponseMessage.success({ message: 'Bin removed Successfully!' });

            } catch (error) {
                console.error("Error in handling selected bin outward:", error);
                setSelectedBins([]);
                ResponseMessage.error({ message: "An error occurred while processing the bin outward operation. Please try again." });
                // message.error("An error occurred while processing the bin outward operation. Please try again.");
            }

        }
    };


    const handleCardClick = (binId) => {
        setSelectedBins((prev) => {
            const newSelectedBins = prev.includes(binId)
                ? prev.filter((id) => id !== binId)
                : [...prev, binId];
            console.log(newSelectedBins);
            return newSelectedBins;
        });
        // navigate(`/manage-bin/view-garment?bin_id=${encodeURIComponent(bin.bin_id)}`);
    };

    return (
        <>
            {contextHolder}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Bin Bulk Outward
                </Typography.Title>
                <Button size="large" type="primary" onClick={() => { navigate("/dispatch/bulkscan/scan") }}>Add Multiple Bin</Button>
            </div>
            <Divider style={{ marginTop: 8 }} />

            <div style={{ marginTop: 16 }}>
                {displayBin.length > 0 ? (
                    <List
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 2,
                            md: 3,
                            lg: 4,
                            xl: 5,
                        }}
                        dataSource={displayBin}
                        renderItem={(bin) => (
                            <List.Item>
                                <Badge
                                    dot={true}
                                    size="large"
                                    style={{
                                        backgroundColor: selectedBins.includes(bin.bin_id)
                                            ? "red"
                                            : "#DCDCDC", // Gray color when not selected
                                        position: "absolute",
                                        top: "9px",
                                        left: "-10px",
                                        width: "20px",
                                        height: "20px",
                                    }}
                                >
                                    <Card
                                        bordered={false}
                                        size="small"
                                        style={{
                                            textAlign: "center",
                                            borderRadius: 8,
                                            width: "50%",
                                            height: "50%",
                                            boxShadow: "none",
                                        }}
                                        onClick={() => {
                                            showRemoveBtn(true);
                                            handleCardClick(bin.bin_id)
                                        }} // Toggle selection
                                        cover={
                                            <img
                                                src={bin_img}
                                                alt="Bin"
                                                style={{ marginBottom: "-20px" }}
                                            />
                                        }
                                    >
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "53%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                color: "white",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    height: 24,
                                                    color: "black",
                                                }}
                                                size="small"
                                            >
                                                <strong>{bin.bin_name}</strong>
                                            </p>
                                        </div>
                                    </Card>
                                </Badge>
                                {/* Tag for quantity */}
                                <Tag
                                    color={bin.bin_full === "yes" ? "#87d068" : "transparent"}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        whiteSpace: "nowrap",
                                        marginBottom: "-10px",
                                        color: bin.bin_full === "yes" ? "white" : "black",
                                        width: "50%",
                                        height: "100%",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        border: bin.bin_full === "yes" ? "none" : "1px solid black",
                                    }}
                                >
                                    {bin.total_quantity || 0} Pcs
                                </Tag>
                            </List.Item>
                        )}
                    />
                ) : (
                    <Empty description="No bins found for the Bulk Outward" />
                )}
            </div>

            <>
                {displayBin && displayBin.length > 0 && (
                    <>
                        {removeBtn && (
                            <Button
                                type="default"
                                size="large"
                                style={{
                                    position: 'fixed',
                                    bottom: '80px', // Positioned above the 'Preview' button
                                    right: '26px',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                                    width: '20%',
                                }}
                                onClick={handleSelectedBinOutward}
                            >
                                Remove Bin
                            </Button>
                        )}

                        <Button
                            type="primary"
                            size="large"
                            style={{
                                position: 'fixed',
                                bottom: '24px',
                                right: '26px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                                width: '20%',
                            }}
                            onClick={handleBulkOutward}
                        >
                            Preview
                        </Button>
                    </>
                )}

            </>

        </>
    );
};
export default BinBlukOutward;